import { select, fork, takeLatest, put, call } from 'redux-saga/effects';
import { getErrorMessageKey } from '../utils/helper';
import { I18N } from '../actions/i18n';
import { changeLanguage, getTranslations, getLanguages } from "../utils/Api";

function* change({ locale }) {
  try {
    const { lang, error: changeError } = yield call(changeLanguage, locale);
    const { translations, error: translationsError } = yield call(getTranslations, locale);
    if (lang && translations) {
      yield put({ type: I18N.CHANGE_LOCALE_DONE, locale });
      yield put({ type: I18N.LOAD_DONE, translations });
    } else {
      const { translations } = yield select(({ i18n }) => i18n);
      const changeMessage = changeError && (getErrorMessageKey(translations, changeError.code) || changeError.msg);
      const translationsMessage = translationsError && (getErrorMessageKey(translations, translationsError.code) || translationsError.msg);
      yield put({ type: I18N.CHANGE_LOCALE_FAILED, message: changeMessage || `error changing locale to ${locale}` });
      yield put({ type: I18N.LOAD_FAILED, message: translationsMessage || 'error loading translations' });
    }
  } catch (message) {
    yield put({ type: I18N.CHANGE_LOCALE_FAILED, message });
  }
}

function* load() {
  try {
    const { locale } = yield select(({ i18n }) => i18n);

    const { translations, error } = yield call(getTranslations, locale);
    if (translations) {
      yield put({ type: I18N.LOAD_DONE, translations });
    } else {
      const { translations } = yield select(({ i18n }) => i18n);
      const message = error && (getErrorMessageKey(translations, error.code) || error.msg);
      yield put({ type: I18N.LOAD_FAILED, message: message || 'error loading translations' });
    }
  } catch (message) {
    yield put({ type: I18N.LOAD_FAILED, message });
  }
}

function* loadLocales() {
  try {
    const { languages } = yield call(getLanguages);
    if (languages) {
      yield put({ type: I18N.LOAD_LOCALES_DONE, languages });
    } else {
      yield put({
        type: I18N.LOAD_LOCALES_FAILED,
        message: "error loading languages",
      });
    }
  } catch (message) {
    yield put({ type: I18N.LOAD_FAILED, message });
  }
}

export default function* () {
  yield [
    fork(function* () { yield takeLatest(I18N.CHANGE_LOCALE, change); }),
    fork(function* () { yield takeLatest(I18N.LOAD, load); }),
    fork(function* () { yield takeLatest(I18N.LOAD_LOCALES, loadLocales); }),
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/i18n.js